import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { base } from './data/base';
import { AppRoutes } from './routers/AppRoutes';
import { BrowserRouter } from 'react-router-dom';
import store from './store';
import { Provider } from 'react-redux';

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <div className='as-mainwrapper'>
          <div className='bg-white'>
            <Header />
            <AppRoutes />
            <Footer
              email={base.email}
              logoW={base.logoWhite}
              logoS={base.logoS}
            />
          </div>
        </div>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
